import React, { useEffect, useState } from 'react';

import { Box, IconButton } from '@mui/material';
import cx from 'classnames';

import CloseIcon from '../../../../assets/icons/CloseIcon';
import useStyles from './styles';

const SEARCH_DELAY = 500;
let timeout;

interface SearchInputProps {
  handleSearch: (val: string) => void;
  delay?: number;
  isFromSearch?: boolean;
  wrapperClass?: string;
  handleClear?: () => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  handleSearch,
  delay = SEARCH_DELAY,
  isFromSearch = false,
  wrapperClass,
  handleClear,
}) => {
  const classes = useStyles();

  const [searchVal, setSearchVal] = useState('');

  const onSearch = (e) => {
    clearTimeout(timeout);
    const val = e.target.value;
    setSearchVal(val);
    timeout = setTimeout(() => {
      handleSearch(val);
    }, delay);
  };

  const onClear = () => {
    setSearchVal('');
    handleClear && handleClear();
  };

  //clear search on outside search state change ,
  // algolia clear RefinementList search in this situation
  useEffect(() => {
    if (!isFromSearch) {
      setSearchVal('');
    }
  }, [isFromSearch]);

  return (
    <Box className={cx(classes.searchWrapper, wrapperClass)}>
      <input type="input" value={searchVal} onChange={onSearch} className={classes.search} />
      {handleClear && searchVal && (
        <IconButton
          className={classes.closeIconWrapper}
          aria-label="clear"
          onClick={onClear}
          size="large">
          <CloseIcon className={classes.closeIcon} />
        </IconButton>
      )}
    </Box>
  );
};

export default SearchInput;
